import { useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
  Divider,
  CircularProgress,
  Chip,
} from "@mui/material";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import "./ModalPresupuesto.css";

import { usePresupuestos } from "../../hooks/usePresupuestos";

const initialForm = {
  nombre_cliente: "",
  apellidos_cliente: "",
  telefono: "",
  precio: "",
  tratamiento: "",
};

const formatFechaPresupuesto = (fecha) => {
  if (!fecha) return "Sin fecha";

  return new Date(fecha)
    .toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    })
    .replace(".", "");
};

export default function ModalPresupuesto({ open, onClose }) {
  const {
    presupuestos,
    loading,
    error,
    crearPresupuesto,
    eliminarPresupuesto,
  } = usePresupuestos();

  const [form, setForm] = useState(initialForm);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCrear = async (e) => {
    e.preventDefault();

    try {
      await crearPresupuesto({
        ...form,
        precio: form.precio ? Number(form.precio) : null,
      });

      setForm(initialForm);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle className="presupuesto-title">
        Presupuestos
      </DialogTitle>

      <DialogContent className="presupuesto-content">
        <form onSubmit={handleCrear} className="presupuesto-form">
          <Box className="presupuesto-row">
            <TextField
              label="Nombre"
              name="nombre_cliente"
              value={form.nombre_cliente}
              onChange={handleChange}
              required
              fullWidth
            />

            <TextField
              label="Apellidos"
              name="apellidos_cliente"
              value={form.apellidos_cliente}
              onChange={handleChange}
              fullWidth
            />
          </Box>

          <Box className="presupuesto-row">
            <TextField
              label="Teléfono"
              name="telefono"
              value={form.telefono}
              onChange={handleChange}
              fullWidth
            />

            <TextField
              label="Precio"
              name="precio"
              type="number"
              value={form.precio}
              onChange={handleChange}
              fullWidth
            />
          </Box>

          <TextField
            label="Tratamiento / trabajo a realizar"
            name="tratamiento"
            value={form.tratamiento}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
          />

          <Box className="presupuesto-actions">
            <Button type="submit" variant="contained">
              Guardar presupuesto
            </Button>

            <Button variant="outlined" onClick={onClose}>
              Cerrar
            </Button>
          </Box>
        </form>

        <Divider sx={{ my: 3 }} />

        <Typography className="presupuesto-subtitle">
          Historial de presupuestos
        </Typography>

        {loading && (
          <Box className="presupuesto-loading">
            <CircularProgress size={28} />
          </Box>
        )}

        {error && <Typography color="error">{error}</Typography>}

        {!loading && presupuestos.length === 0 && (
          <Typography color="text.secondary">
            No hay presupuestos creados.
          </Typography>
        )}

        <Box className="presupuesto-list">
          {presupuestos.map((p) => (
            <Box key={p.id_presupuesto} className="presupuesto-card">
              <Box className="presupuesto-card-main">
                <Box className="presupuesto-card-top">
                  <Chip
                    icon={<CalendarMonthIcon />}
                    label={formatFechaPresupuesto(p.fecha_creacion)}
                    size="small"
                    className="presupuesto-fecha-chip"
                  />
                </Box>

                <Typography className="presupuesto-nombre">
                  {p.nombre_cliente} {p.apellidos_cliente}
                </Typography>

                <Typography className="presupuesto-telefono">
                  {p.telefono || "Sin teléfono"}
                </Typography>

                <Typography className="presupuesto-tratamiento">
                  {p.tratamiento || "Sin tratamiento indicado"}
                </Typography>
              </Box>

              <Box className="presupuesto-card-right">
                <Typography className="presupuesto-precio">
                  {Number(p.precio || 0).toFixed(2)} €
                </Typography>

                <IconButton
                  className="presupuesto-delete"
                  onClick={() => eliminarPresupuesto(p.id_presupuesto)}
                >
                  <DeleteOutlineIcon />
                </IconButton>
              </Box>
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}